import { config } from "../../../config";
import { FormData, UserMarketingProfileResponse } from "../types";
import { updateSessionUMPID } from "../../../lib/session/sessionManager";
import { getKismetClientId } from "../../../lib/utils/getKismetClientId";
import { updateProfile } from "./otpService";

export const generateUserMarketingProfile = async (
  formData: FormData
): Promise<UserMarketingProfileResponse> => {
  try {
    const response = await fetch(
      `${config.backend.base_url}/UserMarketingProfile/AddUserMarketingProfile`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          firstName: formData.firstName,
          lastName: formData.lastName,
          email: formData.email,
          phoneNumber: formData.phone,
          emailMarketingOptIn: formData.marketingConsent,
          smsMarketingOptIn: formData.marketingConsent,
          timestamp: new Date().toISOString(),
          formSource: "GenericForm",
          // These will be handled server-side
          ipAddress: "",
          userId: undefined,
          hotelId: getKismetClientId(),
        }),
      }
    );

    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    const data = await response.json();

    // Log the full response for debugging
    console.log("🔍 API Response:", data);

    // Check for error response first
    if (data.type === "ERROR") {
      console.warn("⚠️ API returned an error:", data.error);
      return data;
    }

    // Then check for success response
    if (data.success) {
      console.log("✅ Marketing Profile Created:", {
        id: data.success.id,
        firstName: data.success.firstName,
        lastName: data.success.lastName,
        createdAt: data.success.createdAt,
        hasEmail: !!data.success.email,
        hasPhone: !!data.success.phoneNumber,
      });

      // Update the session with the UMP ID
      const clientId = getKismetClientId();
      updateSessionUMPID(clientId, data.success.id);

      // Store all necessary data in session storage
      try {
        updateProfile({
          UMP_ID: data.success.id,
          email: data.success.email || null,
          phoneNumber: data.success.phoneNumber || null,
          firstName: data.success.firstName,
          lastName: data.success.lastName,
          createdAt: data.success.createdAt,
          lastUpdated: new Date().toISOString(),
        });

        console.log("✅ Stored profile data in session storage:", {
          id: data.success.id,
          hasEmail: !!data.success.email,
          hasPhone: !!data.success.phoneNumber,
        });
      } catch (storageError) {
        console.error("Failed to store profile data:", storageError);
        // Continue execution even if storage fails
      }
    }

    return data;
  } catch (error) {
    console.error("Error generating marketing profile:", error);
    throw error;
  }
};
